export default {"src":"/login-app/[GIT_HASH]/_next/static/media/eco.1c106472.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};